import { render, staticRenderFns } from "./Directories.vue?vue&type=template&id=1dd5a974"
import script from "./Directories.vue?vue&type=script&lang=js"
export * from "./Directories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports